(function() {
    'use strict';

    angular.module('order').controller('OrderShelfModalController', OrderShelfModalController);

    OrderShelfModalController.$inject = [
        '$uibModalInstance',
        'dataObj',
        'checkModelPermissionsSrvc',
        'notificationSrvc',
        'orderShelfDataSrvc',
        'orderShelfMessagesConst',
        'orderShelfNotificationPermissionsConst',
        'orderShelfNotificationMessagesConst',
        'orderShelfNotificationDataSrvc'
    ];

    function OrderShelfModalController(
        $uibModalInstance, dataObj, checkModelPermissionsSrvc, notificationSrvc, orderShelfDataSrvc,
        orderShelfMessagesConst, orderShelfNotificationPermissionsConst, orderShelfNotificationMessagesConst,
        orderShelfNotificationDataSrvc
    ) {
        var self = this;
        self.loading = false;

        self.serverErrors = {
            order: [],
            number: [],
            code: [],
            non_field_errors: []
        }

        self.orderData = dataObj;
        self.shelfData = {
            order: self.orderData.pk,
            number: "",
            code: ""
        }

        self.formSubmit = formSubmit;
        self.modalClose = modalClose;
        self.cleanErrors = cleanErrors;
        self.getOrderShelfByOrderId = getOrderShelfByOrderId;
        self.canOrderShelfNotificationCreate = canOrderShelfNotificationCreate;
        self.sendNotification = sendNotification;

        activate();

        function activate() {
            getOrderShelfByOrderId(self.orderData.pk);
        }

        function getOrderShelfByOrderId(orderId) {
            self.loading = true;
            return orderShelfDataSrvc.list({order_pk: orderId})
                .$promise
                .then(
                    function (response) {
                        if (response.results.length > 0) {
                            self.shelfData = response.results[0];
                        }
                        return response;
                    }
                ).finally(
                    function (response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function formSubmit() {
            if (!self.shelfData.hasOwnProperty("pk")){
                orderShelfDataSrvc.create(self.shelfData).$promise.then(
                    function (response) {
                        self.shelfData = response;
                        notificationSrvc.notification("success", orderShelfMessagesConst.add);
                    },
                    function (response) {
                        self.serverErrors = response.data;
                        notificationSrvc.notification("error", orderShelfMessagesConst.error);
                    }
                )
            } else {
                orderShelfDataSrvc.update({pk: self.shelfData.pk}, self.shelfData).$promise.then(
                    function (response) {
                        self.shelfData = response;
                        notificationSrvc.notification("success", orderShelfMessagesConst.update);
                    },
                    function (response) {
                        self.serverErrors = response.data;
                        notificationSrvc.notification("error", orderShelfMessagesConst.error);
                    }
                )
            }
        }

        function canOrderShelfNotificationCreate() {
            return !checkModelPermissionsSrvc.isDenied(orderShelfNotificationPermissionsConst.add);
        }

        function sendNotification(){
            if (!self.shelfData.notification && canOrderShelfNotificationCreate()){
                var notificationData = {
                    order: self.orderData.pk,
                    shelfs: [self.shelfData.pk]
                }

                orderShelfNotificationDataSrvc.create(notificationData).$promise.then(
                    function (response) {
                        self.shelfData.notification = response;
                        $uibModalInstance.close(self.shelfData);
                        notificationSrvc.notification("success", orderShelfNotificationMessagesConst.add);
                    },
                    function (response) {
                        self.serverErrors = response.data;
                        notificationSrvc.notification("error", orderShelfNotificationMessagesConst.error);
                    }
                )
            }
        }

        function modalClose() {
            self.orderData = {};
            self.shelfData = {};
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
